// ======================================================================
// File Name       : EnterprisePreCancelForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { reduxForm, submit } from 'redux-form';
import RenderField from '../../utils/ReduxFormUtils';
import { getNextMonthForConfirmCancelEnterprise, getCurrentMonthForNotifyCancelEnterprise } from '../../utils/EnterPriseUtils';

class EnterprisePreCancel extends React.Component {

  render() {
    const { handleSubmit, onChangeCheckbox } = this.props;
    return (
      <Form onSubmit={handleSubmit} className='form-horizontal'>
        <Col className="form-label" sm={12}>
          <p>解約の前のご注意事項を必ずご確認いただき、確認したものにはチェックを入れてください。</p>
          <p className="margin-top-10">全ての内容をご確認いただいた後に解約ボタンを押してください。</p>
        </Col>
        <Col className="form-label" sm={12}>
          <RenderField
            name="checkbox1"
            label={`${getCurrentMonthForNotifyCancelEnterprise()}末日に解約となり、`} // sprint_20230619_1203816014768151
            type="checkbox"
            className="bold"
            radioChange={onChangeCheckbox}
            checkRadioChange
          />
          <ul className="margin-top-10 margin-left-20 bold">
            <li>{getNextMonthForConfirmCancelEnterprise()}以降、管理ユーザー画面や受講ユーザー画面にはアクセスできなくなります。</li> {/* // sprint_20230619_1203816014768151 */}
          </ul>
        </Col>
        <Col className="form-label" sm={12}>
          <RenderField
            name="checkbox2"
            label="アップロード済みコンテンツやデータは必要に応じて事前にエクスポートしてください。"
            type="checkbox"
            className="bold"
            radioChange={onChangeCheckbox}
            checkRadioChange
          />
        </Col>
      </Form>
    );
  }
}

const EnterprisePreCancelForm = reduxForm({
  form: 'enterprisePreCancelForm',
  enableReinitialize: true,
  touchOnChange: false,
  touchOnBlur: true,
})(EnterprisePreCancel);

const mapStateToProps = (state, ownProps) => ({
});
export default connect(mapStateToProps)(EnterprisePreCancelForm);
